export enum FlowType {
	default = "default",
	functionalFirstFromStore = "functional-first-from-store",
	cosmeticFirstFromStore = "cosmetic-first-from-store",
	cosmeticFirstFromHome = "cosmetic-first-from-home",
	retailApp = "retail-app",
}

export const FlowHelpers = {
	isCosmeticFirst: (flow: FlowType): boolean => {
		return flow === FlowType.cosmeticFirstFromStore || flow === FlowType.cosmeticFirstFromHome;
	},

	isFunctionalFirst: (flow: FlowType): boolean => {
		return flow === FlowType.functionalFirstFromStore;
	},
};
